import { loan_application_api } from '@axo/shared/data-access/api';
import { Handler } from '../api-orchestrator';
import { IPreconditions } from '../types/IPreconditions';

interface IDependencies {
  postChild: typeof loan_application_api.postChild;
  deleteChild: typeof loan_application_api.deleteChild;
}

export interface AmountOfChildren {
  AmountOfChildren: string;
}

export const amountOfChildrenHandlerFactory =
  ({
    postChild,
    deleteChild,
  }: IDependencies): Handler<AmountOfChildren, IPreconditions> =>
  async ({
    data: { AmountOfChildren },
    preconditions: { customerJWT, loanApplicationId, amountOfChildrenIds = [] },
    baseUrl,
  }) => {
    const _amountOfChildren = parseInt(AmountOfChildren, 10);

    if (!customerJWT || !loanApplicationId) {
      return { didSync: false };
    }
    const api = { url: { service: baseUrl }, token: customerJWT };

    if (_amountOfChildren === amountOfChildrenIds.length) {
      return { didSync: false };
    }

    if (_amountOfChildren > amountOfChildrenIds.length) {
      const countChildrenToAdd = _amountOfChildren - amountOfChildrenIds.length;
      const children = await Promise.all(
        new Array(countChildrenToAdd)
          .fill(undefined)
          .map(() => postChild(api)(loanApplicationId, {}))
      );
      const ids = children.map((child) => child.ID ?? '');
      return {
        didSync: true,
        newPreconditions: {
          amountOfChildrenIds: [...amountOfChildrenIds, ...ids],
        },
      };
    }

    if (_amountOfChildren < amountOfChildrenIds.length) {
      const countChildrenToRemove =
        amountOfChildrenIds.length - _amountOfChildren;
      const removedIds = await Promise.all(
        amountOfChildrenIds.slice(0, countChildrenToRemove).map(async (id) => {
          await deleteChild(api)(loanApplicationId, id);
          return id;
        })
      );
      return {
        didSync: true,
        newPreconditions: {
          amountOfChildrenIds: amountOfChildrenIds.filter(
            (id) => !removedIds.includes(id)
          ),
        },
      };
    }
    return { didSync: false };
  };
